import { AllSameKeyValuesEnforcer } from "../helpers/helpers";

export interface TableLightColors { yellow, green, red, gray }
export const tableLightColors: AllSameKeyValuesEnforcer<TableLightColors> = { yellow: 'yellow', green: 'green', red: 'red', gray: 'gray' }
export const minContents = (count: number) => Array(count).fill('min-content').join(" ")
